import styled from "styled-components";

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const SummarySection = styled.div`
  display: flex;
  gap: 24px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const LeftColumn = styled.div`
  flex: 1;
`;

export const RightColumn = styled.div`
  width: 345px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 24px 0 12px;

  &:first-child {
    margin-top: 0;
  }
`;

export const SummaryCard = styled.div`
  background: white;
  border: 1px dashed #e8e8e8;
  border-radius: 8px;
  padding: 20px;
`;

export const SummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const SummaryLabel = styled.div`
  font-size: 14px;
  color: #666;
`;

export const SummaryValue = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #333;
  text-align: right;
`;

export const SummaryTotal = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: right;
`;

export const SummaryDivider = styled.div`
  height: 1px;
  background: #e8e8e8;
  margin: 16px 0;
`;

export const TermsText = styled.div`
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 12px;
`;

export const TermsLink = styled.a`
  color: #0066ff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;